import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button, Label } from 'reactstrap';
import '../../dashboard/default/StyleSendResults.css';
import { ModalSendEmail } from './ModalSendEmail';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { labcen } from '../../../constant/globalConstantsTypeClients';

export const ModalExamsEmail = ({
    toggleListExamEmail,
    modalExamsEmail,
    dataExams,
    handleCheckProfile,
    handleCheckAll,
    handleCheckAllProfile,
    sending,
    loading,
    respuestaAPI, sendResultEmail, handleSendEmail, sendConfig,
    setStep, setAuditPanel, auditPanel, markAllActive, handleMarkAllClick, step,
    isSelectable, statusMap, toggleAuditPanel, toggleProfile, openProfiles, selectedCount, resetModalExamEmail,
    letter, handleInputChange, getFullAuditHistory, getStatus, _url_helen

}) => {

    // console.log("🫒 auditPanel", auditPanel);

    // console.log("🥑 dataExams", dataExams);
    let enable_whatsapp = localStorage.getItem('enable_whatsapp');


    const headerStyle = {
        backgroundColor: "#0d3b59",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const [auditRows, setAuditRows] = useState(3);
    const [auditDialogHeight, setAuditDialogHeight] = useState(null);

    useEffect(() => {

        if (!auditPanel) return;

        const updateAuditSize = () => {

            const mainDialog = document.querySelector(
                ".results-digital-modal.p-dialog"
            );

            if (!mainDialog) return;

            const height = mainDialog.getBoundingClientRect().height;

            console.log("Altura modal principal:", height);

            setAuditDialogHeight(height);

            if (height <= 360) {
                setAuditRows(3);
            }
            else if (height <= 470) {
                setAuditRows(4);
            }
            else {
                setAuditRows(6);
            }
        };

        requestAnimationFrame(updateAuditSize);

        const mainDialog = document.querySelector(
            ".results-digital-modal.p-dialog"
        );

        if (!mainDialog) return;

        const observer = new ResizeObserver(() => {
            updateAuditSize();
        });

        observer.observe(mainDialog);

        return () => {
            observer.disconnect();
        };

    }, [auditPanel, step]);

    const renderAuditTable = (list) => {
        // if (!list || list.length === 0) return <span>Sin envíos</span>;
        return (
            <div className="table-responsive">
                <DataTable
                    value={list}
                    paginator
                    rows={auditRows}
                    rowsPerPageOptions={[3, 4, 6, 10, 50]}
                    responsiveLayout="scroll"
                    className="data-table p-datatable-striped p-datatable-sm"
                    emptyMessage={
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "32%" }}
                                alt="Sin resultados"
                            />
                            <br />
                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                No se encontraron resultados.
                            </p>
                        </div>
                    }
                >

                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                    <Column header="Destino"
                        body={(rowData) => {
                            if (rowData.sent_to === "DOCTOR") return "Médico";
                            if (rowData.sent_to === "PATIENT") return "Paciente";
                            if (rowData.sent_to === "PRINT") return "Impresión";
                            if (rowData.sent_to === "RECEPTION") return "Recepción";
                            return rowData.sent_to;
                        }}
                        headerStyle={headerStyle} style={centerStyle} />

                    <Column
                        header="Hora de envío"
                        headerStyle={headerStyle}
                        style={centerStyle}
                        body={(rowData) => {

                            if (!rowData.send_date) return "";

                            const date = new Date(rowData.send_date);

                            const formatted = date.toLocaleString("es-MX", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true
                            });

                            return formatted;
                        }}
                    />
                    <Column field="user_name" header="Usuario" headerStyle={headerStyle} style={centerStyle} />
                    <Column
                        body={(rowData) => {

                            if (rowData.sent_to === "RECEPTION") {
                                return "Botón de entregado en el dashboard";
                            }

                            if (rowData.sent_to === "PRINT") {
                                return "Impreso";
                            }

                            if (rowData.email_sent_to) {
                                return rowData.email_sent_to;
                            }

                            return "-";
                        }}
                        header="Método de envío"
                        headerStyle={{
                            ...headerStyle,
                            width: "180px"
                        }}
                        style={{
                            ...centerStyle,
                            width: "180px",
                            maxWidth: "180px",
                            whiteSpace: "normal",
                            overflowWrap: "anywhere",
                            wordBreak: "break-word"
                        }}
                    />


                    <Column
                        header="Estatus"
                        headerStyle={headerStyle}
                        style={centerStyle}
                        body={(rowData) => {

                            const status = rowData.status_name?.toLowerCase();

                            let className = "status-default";

                            if (status === "enviado") {
                                className = "status-enviado";
                            }

                            if (status === "impreso") {
                                className = "status-impreso";
                            }

                            return (
                                <span className={`status-badge-print-results ${className}`}>
                                    {rowData.status_name}
                                </span>
                            );
                        }}
                    />
                </DataTable>
            </div>
        );
    };
    

    return (
        <Dialog
            visible={modalExamsEmail}
            onHide={() => {
                toggleListExamEmail();
            }}
            header="Resultados: envío e impresión"
            modal
            className={`results-digital-modal ${auditPanel ? "audit-open" : ""}`}
            maskClassName="results-digital-mask"
            draggable={false}
        >

            <div className="results-layout">
                <div className="results-main">
                    <div className="results-container">
                        {step === 1 && (
                            <>
                                <div className="results-top">
                                    <span>SELECCIÓN DE RESULTADOS</span>

                                    <button className={`mark-all-btn ${markAllActive ? "active" : ""}`} onClick={handleMarkAllClick}>
                                        MARCAR TODO
                                    </button>
                                </div>
                                <div className="results-list">

                                    {dataExams.map((item, i) => {
                                        const status = getStatus(item.id_estatus);

                                        const profileSelectable = isSelectable(item.id_estatus, item.show_print);
                                        const formatSendDate = (dateString) => {
                                            if (!dateString) return "";

                                            const date = new Date(dateString);

                                            return date.toLocaleString("es-MX", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "numeric",
                                                minute: "2-digit",
                                                hour12: true
                                            });
                                        };


                                        if (item.id_profile === null) {

                                            return (
                                                <div
                                                    key={i}
                                                    className={`exam-card 
                                                    ${item.check_box ? "selected" : ""} 
                                                    ${!profileSelectable ? "disabled" : ""}`}
                                                >
                                                    <Label className="exam-left">
                                                        <input
                                                            type="checkbox"
                                                            checked={item.check_box}
                                                            disabled={!profileSelectable}
                                                            onChange={(e) =>
                                                                handleCheckProfile(
                                                                    e,
                                                                    null,
                                                                    item.id_exam,
                                                                    null,
                                                                    item.id_work_order_exam
                                                                )
                                                            }
                                                        />

                                                        <span className="custom-check" />
                                                        <div className="exam-info">
                                                            <span className="exam-name mt-2">{item.name}</span>
                                                                <span className="badge-sending-time">
                                                                    {item.sendBy?.sended_at
                                                                        ? `${
                                                                            item.id_estatus === 13 && _url_helen === labcen
                                                                                ? "Impreso"
                                                                                : "Entregado"
                                                                        }: ${formatSendDate(item.sendBy.sended_at)}`
                                                                        : ""
                                                                    }
                                                                </span>
                                                        </div>




                                                    </Label>
                                                    <div className="exam-right-block">
                                                       <span className={`exam-badge ${status.class}`}>
                                                            {status.label}
                                                        </span>

                                                        <div className="exam-send-info">

                                                            {/* PACIENTE */}
                                                            <span
                                                                className="send-destination"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if ((item.sends_to_patient ?? 0) > 0 || (item.print_audit_details?.length ?? 0) > 0) {
                                                                        const patientHistory = [
                                                                            ...(item.patient_audit_details || []),
                                                                            ...(item.print_audit_details || [])
                                                                        ];

                                                                        toggleAuditPanel(
                                                                            "PATIENT",
                                                                            item.id_work_order_exam,
                                                                            patientHistory,
                                                                            item.name
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <span className="destination-label">
                                                                    <i className="fa fa-user"></i>
                                                                </span>

                                                                <span className="destination-methods">

                                                                    <span className="method email">

                                                                        <i className="fa fa-envelope"></i> {item.patient_audit_details?.filter(x => x.email_sent_to).length ?? 0}

                                                                    </span>

                                                                    {enable_whatsapp === "True" && (
                                                                        <span className="method whatsapp">
                                                                            <i className="fa fa-whatsapp"></i>

                                                                        </span>
                                                                    )}

                                                                    <span className="method print">
                                                                        <i className="fa fa-print"></i>{item.print_audit_details?.length ?? 0}

                                                                    </span>

                                                                </span>
                                                            </span>


                                                            {/* MÉDICO */}
                                                            <span
                                                                className="send-destination"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if ((item.sends_to_patient ?? 0) > 0 || (item.print_audit_details?.length ?? 0) > 0) {
                                                                        toggleAuditPanel(
                                                                            "DOCTOR",
                                                                            item.id_work_order_exam,
                                                                            item.doctor_audit_details,
                                                                            item.name
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <span className="destination-label">
                                                                    <i className="fa fa-user-md"></i>
                                                                </span>

                                                                <span className="destination-methods">

                                                                    <span className="method email">
                                                                        <i className="fa fa-envelope"></i> {item.doctor_audit_details?.filter(x => x.email_sent_to).length ?? 0}
                                                                    </span>

                                                                    {enable_whatsapp === "True" && (
                                                                        <span className="method whatsapp">
                                                                            <i className="fa fa-whatsapp"></i>
                                                                        </span>
                                                                    )}

                                                                </span>
                                                            </span>

                                                            <span
                                                                className="send-count history"
                                                                title="Histórico de Resultados"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();

                                                                    const history = getFullAuditHistory(item);

                                                                    if (history.length > 0) {
                                                                        toggleAuditPanel(
                                                                            "ALL",
                                                                            item.id_work_order_exam,
                                                                            history,
                                                                            item.name
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <i className="fa fa-history"></i>

                                                                <span className="history-count">
                                                                    {getFullAuditHistory(item).length}
                                                                </span>
                                                            </span>


                                                        </div>

                                                    </div>
                                                </div>
                                            );
                                        }
                                        const lastSend = item.listExam
                                            ?.filter(e => e.sendBy?.sended_at)
                                            ?.map(e => new Date(e.sendBy.sended_at))
                                            ?.sort((a, b) => b - a)[0];

                                        const formattedSendDate = lastSend
                                            ? lastSend.toLocaleString("es-MX", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "numeric",
                                                minute: "2-digit",
                                                hour12: true
                                            })
                                            : null;

                                        const profileStatus = getStatus(item.id_estatus);


                                        return (
                                            <div key={i} className="profile-wrapper">

                                                <div
                                                    className={`profile-header ${openProfiles[item.id_profile] ? "open" : ""} ${!profileSelectable ? "disabled" : ""}`}
                                                    onClick={() => toggleProfile(item.id_profile)}
                                                >

                                                    <div className="exam-left">
                                                        <input
                                                            type="checkbox"
                                                            checked={item.check_box}
                                                            disabled={!profileSelectable}
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={(e) => {
                                                                e.stopPropagation();
                                                                handleCheckAllProfile(
                                                                    e,
                                                                    item.id_profile,
                                                                    item.id_work_order_profile
                                                                );
                                                            }}
                                                        />

                                                       <span
                                                            className="custom-check"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleCheckAllProfile(
                                                                { target: { checked: !item.check_box } },
                                                                item.id_profile,
                                                                item.id_work_order_profile
                                                                );
                                                            }}
                                                        />
                                                        <div onClick={() => toggleProfile(item.id_profile)}>
                                                            <div className="profile-title">{item.name}</div>

                                                            {/* <span className="badge-sending-time">
                                                                {formattedSendDate
                                                                    ? `${item.status_profile === "IMPRESO" ? "Entregado" : "Entregado"}: ${formattedSendDate}`
                                                                    : ""
                                                                }
                                                            </span> */}
                                                            <span className="badge-sending-time">
                                                                {formattedSendDate
                                                                    ? `${
                                                                        item.id_estatus === 13 && _url_helen === labcen
                                                                            ? "Impreso"
                                                                            : "Entregado"
                                                                    }: ${formattedSendDate}`
                                                                    : ""
                                                                }
                                                            </span>

                                                        </div>
                                                    </div>


                                                    <div className="profile-right">

                                                        <div className="profile-status-block">
                                                            <span className={`exam-badge ${profileStatus.class}`}>
                                                                {profileStatus.label}
                                                            </span>
                                                            <div className="profile-sub">
                                                                {item.sent_exams} DE {item.total_exams} COMPLETADOS
                                                            </div>
                                                        </div>

                                                        <span className="profile-arrow">
                                                            {openProfiles[item.id_profile] ? "▴" : "▾"}
                                                        </span>

                                                    </div>


                                                </div>


                                                {openProfiles[item.id_profile] && (
                                                    <div className="tree-children">

                                                        {item.listExam.map((exam, j) => {

                                                            const examSelectable = isSelectable(exam.id_estatus, exam.show_print);
                                                            const formatSendDate = (dateString) => {
                                                                if (!dateString) return "";

                                                                const date = new Date(dateString);

                                                                return date.toLocaleString("es-MX", {
                                                                    day: "2-digit",
                                                                    month: "2-digit",
                                                                    year: "numeric",
                                                                    hour: "numeric",
                                                                    minute: "2-digit",
                                                                    hour12: true
                                                                });
                                                            };
                                                            const examStatus = getStatus(exam.id_estatus);


                                                            return (
                                                                <div
                                                                    key={j}
                                                                    className={`tree-exam-row
                                                                    ${exam.check_box ? "selected" : ""}
                                                                    ${!examSelectable ? "disabled" : ""}`}
                                                                >
                                                                    <label className="exam-left">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={exam.check_box}
                                                                            disabled={!examSelectable}
                                                                            onChange={(e) =>
                                                                                handleCheckProfile(
                                                                                    e,
                                                                                    item.id_profile,
                                                                                    exam.id_exam,
                                                                                    item.id_work_order_profile,
                                                                                    exam.id_work_order_exam
                                                                                )
                                                                            }
                                                                        />
                                                                        <span className="custom-check" />
                                                                        <div className="tree-exam-info">
                                                                            <span className="exam-name">{exam.name}</span>
                                                                            {/* <i className='fa fa-paper-plane'></i> */}

                                                                            {/* <span className="badge-sending-time">
                                                                                {exam.sendBy?.sended_at
                                                                                    ? `${exam.id_estatus === 13 ? "Entregado" : exam.id_estatus === 7 ? "Entregado" : ""}: ${formatSendDate(exam.sendBy.sended_at)}`
                                                                                    : ""
                                                                                }
                                                                            </span> */}
                                                                            <span className="badge-sending-time">
                                                                                {exam.sendBy?.sended_at
                                                                                    ? `${
                                                                                        exam.id_estatus === 13 && _url_helen === labcen
                                                                                            ? "Impreso"
                                                                                            : "Entregado"
                                                                                    }: ${formatSendDate(exam.sendBy.sended_at)}`
                                                                                    : ""
                                                                                }
                                                                            </span>
                                                                        </div>


                                                                    </label>

                                                                  
                                                                    <div className="exam-right-block">
                                                                       <span className={`exam-badge ${examStatus.class}`}>
                                                                            {examStatus.label}
                                                                        </span>
                                                                        <div className="exam-send-info">
                                                                         
                                                                            <span
                                                                                className="send-destination"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    if ((exam.sends_to_patient ?? 0) > 0 || (exam.print_audit_details?.length ?? 0) > 0) {
                                                                                        const patientHistory = [
                                                                                            ...(exam.patient_audit_details || []),
                                                                                            ...(exam.print_audit_details || [])
                                                                                        ];

                                                                                        toggleAuditPanel(
                                                                                            "PATIENT",
                                                                                            exam.id_work_order_exam,
                                                                                            patientHistory,
                                                                                            exam.name
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span className="destination-label">
                                                                                    <i className="fa fa-user"></i>
                                                                                </span>

                                                                                <span className="destination-methods">

                                                                                    <span className="method email">

                                                                                        <i className="fa fa-envelope"></i> {exam.patient_audit_details?.filter(x => x.email_sent_to).length ?? 0}

                                                                                    </span>

                                                                                    {enable_whatsapp === "True" && (
                                                                                        <span className="method whatsapp">
                                                                                            <i className="fa fa-whatsapp"></i>

                                                                                        </span>
                                                                                    )}

                                                                                    <span className="method print">
                                                                                        <i className="fa fa-print"></i>{exam.print_audit_details?.length ?? 0}

                                                                                    </span>

                                                                                </span>
                                                                            </span>

                                                                            <span
                                                                                className="send-destination"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    if ((exam.sends_to_doctor ?? 0)) {
                                                                                        toggleAuditPanel(
                                                                                            "DOCTOR",
                                                                                            exam.id_work_order_exam,
                                                                                            exam.doctor_audit_details,
                                                                                            exam.name
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span className="destination-label">
                                                                                    <i className="fa fa-user-md"></i>
                                                                                </span>

                                                                                <span className="destination-methods">

                                                                                    <span className="method email">
                                                                                        <i className="fa fa-envelope"></i> {exam.doctor_audit_details?.filter(x => x.email_sent_to).length ?? 0}
                                                                                    </span>

                                                                                    {enable_whatsapp === "True" && (
                                                                                        <span className="method whatsapp">
                                                                                            <i className="fa fa-whatsapp"></i>
                                                                                        </span>
                                                                                    )}

                                                                                </span>
                                                                            </span>

                                                                            <span
                                                                                className="send-count history"
                                                                                title='Histórico de Resultados'
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();

                                                                                    const history = getFullAuditHistory(exam);

                                                                                    if (history.length > 0) {
                                                                                        toggleAuditPanel(
                                                                                            "ALL",
                                                                                            exam.id_work_order_exam,
                                                                                            history,
                                                                                            exam.name
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-history"></i>
                                                                            </span>


                                                                        </div>

                                                                    </div>

                                                                </div>



                                                            );
                                                        })}

                                                    </div>
                                                )}

                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="results-footer">
                                    <Button
                                        className="next-btn"
                                        onClick={() => {
                                            setStep(2);
                                        }}
                                        disabled={loading || selectedCount === 0}
                                    >
                                        <Label>
                                            SIGUIENTE ({selectedCount}) <i className="fa fa-angle-right"></i>
                                        </Label>
                                    </Button>
                                </div>
                            </>
                        )}

                        {step === 2 && (
                            <ModalSendEmail
                                respuestaAPI={respuestaAPI}
                                onBack={() => setStep(1)}
                                onSend={handleSendEmail}
                                sendConfig={sendConfig}
                                sending={sending}
                                letter={letter}
                                handleInputChange={handleInputChange}
                            />
                        )}

                    </div>
                </div>


                {auditPanel && (
                    <Dialog
                        visible={!!auditPanel}
                        onHide={() => setAuditPanel(null)}
                        header={`Historial de resultados de ${auditPanel?.nameExam ?? ""}`}
                        className="audit-dialog"
                        modal={false}
                        draggable={false}
                        resizable={false}
                    >
                        <br />
                        {auditPanel && renderAuditTable(auditPanel.data)}
                    </Dialog>
                )}

            </div>

        </Dialog>
    );
};


